/**
 * Stellar, animated-shader-hero (Matthias Hurrle / @atzedent)
 * Benchmark @atzedent, animation originale ; gaz Stellar (stellarGas) pour itération.
 */
(function () {
 'use strict';

 var BENCHMARK_SHADER =
 '#version 300 es\n' +
 '/*********\n' +
 '* made by Matthias Hurrle (@atzedent)\n' +
 '*\n' +
 '*\tTo explore strange new worlds, to seek out new life\n' +
 '*\tand new civilizations, to boldly go where no man has\n' +
 '*\tgone before.\n' +
 '*/\n' +
 'precision highp float;\n' +
 'out vec4 O;\n' +
 'uniform vec2 resolution;\n' +
 'uniform float time;\n' +
 '#define FC gl_FragCoord.xy\n' +
 '#define T time\n' +
 '#define R resolution\n' +
 '#define MN min(R.x,R.y)\n' +
 '// Returns a pseudo random number for a given point (white noise)\n' +
 'float rnd(vec2 p) {\n' +
 ' p=fract(p*vec2(12.9898,78.233));\n' +
 ' p+=dot(p,p+34.56);\n' +
 ' return fract(p.x*p.y);\n' +
 '}\n' +
 '// Returns a pseudo random number for a given point (value noise)\n' +
 'float noise(in vec2 p) {\n' +
 ' vec2 i=floor(p), f=fract(p), u=f*f*(3.-2.*f);\n' +
 ' float\n' +
 ' a=rnd(i),\n' +
 ' b=rnd(i+vec2(1,0)),\n' +
 ' c=rnd(i+vec2(0,1)),\n' +
 ' d=rnd(i+1.);\n' +
 ' return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);\n' +
 '}\n' +
 '// Returns a pseudo random number for a given point (fractal noise)\n' +
 'float fbm(vec2 p) {\n' +
 ' float t=.0, a=1.; mat2 m=mat2(1.,-.5,.2,1.2);\n' +
 ' for (int i=0; i<5; i++) {\n' +
 ' t+=a*noise(p);\n' +
 ' p*=2.*m;\n' +
 ' a*=.5;\n' +
 ' }\n' +
 ' return t;\n' +
 '}\n' +
 'float clouds(vec2 p) {\n' +
 '\tfloat d=1., t=.0;\n' +
 '\tfor (float i=.0; i<3.; i++) {\n' +
 '\t\tfloat a=d*fbm(i*10.+p.x*.2+.2*(1.+i)*p.y+d+i*i+p);\n' +
 '\t\tt=mix(t,d,a);\n' +
 '\t\td=a;\n' +
 '\t\tp*=2./(i+1.);\n' +
 '\t}\n' +
 '\treturn t;\n' +
 '}\n' +
 'vec3 stellarGas(float bg) {\n' +
 '\tvec3 deep = vec3(0.05, 0.04, 0.11);\n' +
 '\tvec3 mid = vec3(0.10, 0.09, 0.20);\n' +
 '\tvec3 glow = vec3(0.18, 0.16, 0.32);\n' +
 '\treturn mix(deep, mid, clamp(bg, 0.0, 1.0)) + glow * bg * bg * 0.2;\n' +
 '}\n' +
 'void main(void) {\n' +
 '\tvec2 uv=(FC-.5*R)/MN;\n' +
 '\tuv=vec2(uv.y,-uv.x);\n' +
 '\tvec2 st=uv*vec2(2,1);\n' +
 '\tvec3 col=vec3(0);\n' +
 '\tfloat bg=clouds(vec2(st.x+T*.5,-st.y));\n' +
 '\tuv*=1.-.3*(sin(T*.2)*.5+.5);\n' +
 '\tfor (float i=1.; i<12.; i++) {\n' +
 '\t\tuv+=.1*cos(i*vec2(.1+.01*i, .8)+i*i+T*.5+.1*uv.x);\n' +
 '\t\tvec2 p=uv;\n' +
 '\t\tfloat d=length(p);\n' +
 '\t\tcol+=.00125/d*(cos(sin(i)*vec3(1,2,3))+1.);\n' +
 '\t\tfloat b=noise(i+p+bg*1.731);\n' +
 '\t\tcol+=.002*b/length(max(p,vec2(b*p.x*.02,p.y)));\n' +
 '\t\tcol=mix(col,stellarGas(bg),d);\n' +
 '\t}\n' +
 '\tO=vec4(col,1);\n' +
 '}';

 function WebGLRenderer(canvas, scale) {
 this.canvas = canvas;
 this.scale = scale;
 this.gl = canvas.getContext('webgl2', { alpha: false, antialias: false });
 if (!this.gl) return;
 this.gl.viewport(0, 0, canvas.width * scale, canvas.height * scale);
 this.shaderSource = BENCHMARK_SHADER;
 this.vertices = [-1, 1, -1, -1, 1, 1, 1, -1];
 this.vertexSrc =
 '#version 300 es\nprecision highp float;\nin vec4 position;\nvoid main(){gl_Position=position;}';
 }

 WebGLRenderer.prototype.compile = function (shader, source) {
 var gl = this.gl;
 gl.shaderSource(shader, source);
 gl.compileShader(shader);
 if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
 console.warn('Stellar galaxy shader:', gl.getShaderInfoLog(shader));
 }
 };

 WebGLRenderer.prototype.setup = function () {
 var gl = this.gl;
 this.vs = gl.createShader(gl.VERTEX_SHADER);
 this.fs = gl.createShader(gl.FRAGMENT_SHADER);
 this.compile(this.vs, this.vertexSrc);
 this.compile(this.fs, this.shaderSource);
 this.program = gl.createProgram();
 gl.attachShader(this.program, this.vs);
 gl.attachShader(this.program, this.fs);
 gl.linkProgram(this.program);
 if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) {
 console.warn('Stellar galaxy shader:', gl.getProgramInfoLog(this.program));
 }
 };

 WebGLRenderer.prototype.init = function () {
 var gl = this.gl;
 var program = this.program;
 this.buffer = gl.createBuffer();
 gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
 gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(this.vertices), gl.STATIC_DRAW);
 var position = gl.getAttribLocation(program, 'position');
 gl.enableVertexAttribArray(position);
 gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
 this.uniforms = {
 resolution: gl.getUniformLocation(program, 'resolution'),
 time: gl.getUniformLocation(program, 'time')
 };
 };

 WebGLRenderer.prototype.render = function (now) {
 var gl = this.gl;
 var program = this.program;
 if (!program) return;
 gl.clearColor(0, 0, 0, 1);
 gl.clear(gl.COLOR_BUFFER_BIT);
 gl.useProgram(program);
 gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
 gl.uniform2f(this.uniforms.resolution, this.canvas.width, this.canvas.height);
 gl.uniform1f(this.uniforms.time, now * 1e-3);
 gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
 };

 WebGLRenderer.prototype.updateScale = function (scale) {
 this.scale = scale;
 this.gl.viewport(0, 0, this.canvas.width * scale, this.canvas.height * scale);
 };

 WebGLRenderer.prototype.destroy = function () {
 var gl = this.gl;
 if (this.program) gl.deleteProgram(this.program);
 if (this.vs) gl.deleteShader(this.vs);
 if (this.fs) gl.deleteShader(this.fs);
 this.program = null;
 };

 function initGalaxy(section) {
 if (!section || section.dataset.galaxyInit === 'true') return;

 var host = section.querySelector('[data-galaxy-shader-host]');
 var canvas = section.querySelector('[data-galaxy-shader-canvas]');
 if (!host || !canvas) return;

 if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
 section.classList.add('is-galaxy-static');
 return;
 }

 var dpr = Math.max(1, 0.5 * (window.devicePixelRatio || 1));
 var renderer = new WebGLRenderer(canvas, dpr);
 if (!renderer.gl) {
 section.classList.add('is-galaxy-static');
 return;
 }

 section.dataset.galaxyInit = 'true';
 renderer.setup();
 renderer.init();

 var raf = 0;

 function resize() {
 var rect = host.getBoundingClientRect();
 dpr = Math.max(1, 0.5 * (window.devicePixelRatio || 1));
 canvas.width = Math.max(2, Math.floor(rect.width * dpr));
 canvas.height = Math.max(2, Math.floor(rect.height * dpr));
 canvas.style.width = rect.width + 'px';
 canvas.style.height = rect.height + 'px';
 renderer.updateScale(dpr);
 }

 function loop(now) {
 resize();
 renderer.render(now);
 raf = requestAnimationFrame(loop);
 }

 resize();
 raf = requestAnimationFrame(loop);

 window.addEventListener('resize', resize);
 if (window.ResizeObserver) {
 new ResizeObserver(resize).observe(host);
 }

 section.addEventListener('shopify:section:unload', function () {
 cancelAnimationFrame(raf);
 renderer.destroy();
 });
 }

 function boot() {
 document.querySelectorAll('[data-stellar-galaxy]').forEach(initGalaxy);
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', boot);
 } else {
 boot();
 }
 document.addEventListener('shopify:section:load', boot);
})();
